/** Checklist template helpers for job / visit-group checklists. */

export interface ChecklistTemplateItem {
  label: string
  sort_order: number
  /** When true, a photo linked to this task is required before job completion. */
  photo_required?: boolean
}

export interface ChecklistTemplateOption {
  id: string
  name: string
  description?: string | null
  service_type?: string | null
  items: ChecklistTemplateItem[]
  is_system?: boolean
  source: 'saved'
}

export function normalizeChecklistItems(
  items:
    | Array<{ label?: string; sort_order?: number; photo_required?: boolean } | string>
    | null
    | undefined
): ChecklistTemplateItem[] {
  if (!Array.isArray(items)) return []
  return items
    .map((item, index) => {
      if (typeof item === 'string') {
        return { label: item.trim(), sort_order: index, photo_required: false }
      }
      return {
        label: String(item.label || '').trim(),
        sort_order: typeof item.sort_order === 'number' ? item.sort_order : index,
        photo_required: !!item.photo_required,
      }
    })
    .filter((item) => item.label.length > 0)
    .sort((a, b) => a.sort_order - b.sort_order)
    .map((item, index) => ({ ...item, sort_order: index }))
}

export function checklistItemsForSave(
  items: Array<{ label?: string; sort_order?: number }>
): ChecklistTemplateItem[] {
  return normalizeChecklistItems(items)
}

/** Prefer templates matching serviceType, then the rest. */
export function sortTemplatesForServiceType(
  templates: ChecklistTemplateOption[],
  serviceType?: string | null
): ChecklistTemplateOption[] {
  if (!serviceType) return templates
  const matching: ChecklistTemplateOption[] = []
  const rest: ChecklistTemplateOption[] = []
  for (const t of templates) {
    if (t.service_type === serviceType) matching.push(t)
    else rest.push(t)
  }
  return [...matching, ...rest]
}
